import { Icon } from '@/components/ds'
import { puntajeContrasena, reglasContrasena } from '@/lib/contrasena'
import { cn } from '@/lib/utils'

const ETIQUETAS = ['', 'Débil', 'Aceptable', 'Buena', 'Fuerte'] as const

/** Un color por nivel. `text-soft` para el 0, que es "todavía no escribiste nada". */
const TONOS = [
  'text-soft',
  'text-destructive',
  'text-warning',
  'text-primary-hover',
  'text-success',
] as const

const BARRAS = [
  'bg-border-subtle',
  'bg-destructive',
  'bg-warning',
  'bg-primary-hover',
  'bg-success',
] as const

/** Etiqueta del nivel, para colgarla del label del campo. */
export function EtiquetaFuerza({ clave }: { clave: string }) {
  const n = puntajeContrasena(clave)
  return <span className={cn('text-[11px] font-medium', TONOS[n])}>{ETIQUETAS[n]}</span>
}

/**
 * Medidor de fuerza: cuatro barras + las reglas que faltan.
 *
 * Las reglas listadas son TRES y el puntaje llega a CUATRO a propósito: el
 * símbolo suma pero no se pide. Mostrarlo como regla lo convertiría en
 * obligatorio a los ojos de la persona, y no lo es ni acá ni en el backend.
 */
export function FuerzaContrasena({ clave }: { clave: string }) {
  const n = puntajeContrasena(clave)

  return (
    <>
      <div className="flex items-center gap-1" aria-hidden="true">
        {[0, 1, 2, 3].map((i) => (
          <div
            key={i}
            className={cn(
              'h-1 flex-1 rounded-full transition-colors',
              i < n ? BARRAS[n] : 'bg-border-subtle'
            )}
          />
        ))}
      </div>
      <div className="flex flex-wrap gap-[9px]">
        {reglasContrasena(clave).map((regla) => (
          <span
            key={regla.label}
            className={cn(
              'inline-flex items-center gap-1 text-[10.5px]',
              regla.ok ? 'text-success' : 'text-soft'
            )}
          >
            <Icon name={regla.ok ? 'check_circle' : 'radio_button_unchecked'} size={13} />
            {regla.label}
          </span>
        ))}
      </div>
    </>
  )
}
